<template>
  <div class="overlay_con" v-if="showOverlay">
    <div
      :style="{
        height: '100%',
        background: datas.backColor,
        'padding-top': datas.paddingTop + 'px',
        'padding-bottom': datas.paddingBottom + 'px',
        'padding-left': datas.paddingLeft + 'px',
        'padding-right': datas.paddingRight + 'px',
        'border-style': datas.borderStyle,
        'border-color': datas.borderColor,
        'border-width': datas.borderLineWeight + 'px',
        'border-radius': datas.borderRadius + 'px',
        'margin-top': datas.marginTop + 'px',
        'margin-bottom': datas.marginBottom + 'px',
        'margin-left': datas.marginLeft + 'px',
        'margin-right': datas.marginRight + 'px',
      }"
    >
      <!-- 无图片 -->
      <div v-if="!imageList[0]" class="empty_con">
        <img src="@/assets/images/defaultPic2.png" alt="" />
      </div>

      <div v-if="imageList[0]" class="swiper-container">
        <div :class="'swiper-wrapper type1'">
          <!-- <div class="swiper-wrapper type1"> -->
          <div
            v-for="(item, index) in imageList"
            :key="index"
            class="swiper-slide"
            @click="handleClickImg(item)"
          >
            <!-- 图片 -->
            <img :src="item.imgUrl" alt="" draggable="false" />
          </div>
        </div>

        <!-- 分页器 -->
        <div class="swiper-pagination" />
      </div>
    </div>
    <div
      v-if="datas.showSkipBtn || (!datas.showSkipBtn && timeOut)"
      class="skip_btn"
      :style="{
        background: datas.skipBtnBgColor,
        color: datas.skipBtnColor,
      }"
      @click="handleCloseOverlay"
    >
      {{ timeOut ? "关闭" : "跳过 " + countdownTime }}
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import { handleScanCode } from "@/utils";
export default {
  name: "Overlay",
  props: {
    datas: Object,
  },
  data() {
    return {
      showOverlay: true,
      mySwiper: null,
      countdownTime: this.datas.countdown,
      timeOut: false,
    };
  },
  computed: {
    /* 图片删除或者增加 */
    imageList() {
      this.addSwiper();
      return this.datas.imageList;
    },
  },
  watch: {},
  mounted() {
    this.timeId = setInterval(() => {
      if (this.countdownTime == 1) {
        clearInterval(this.timeId);
        this.timeOut = true;
        return;
      }
      this.countdownTime--;
    }, 1000);
  },
  methods: {
    /* 创建轮播对象 */
    addSwiper() {
      this.$nextTick(() => {
        if (this.datas.imageList[0]) {
          if (this.mySwiper instanceof Array) {
            this.mySwiper.forEach((element) => {
              element.destroy();
            });
          } else if (this.mySwiper instanceof Object) {
            // 每次重新创建swiper前都要销毁之前存在的轮播   不然轮播会重复
            this.mySwiper.destroy();
          }

          const params = {
            // loop: true,
            slidesPerView: 1,
            // spaceBetween: 17,
            // autoplay: true,
            autoplay: {
              delay: this.datas.carouselInterval,
            },
            pagination: {
              el: ".swiper-pagination",
              type: "bullets",
            },
          };

          this.mySwiper = new Swiper(".swiper-container", params);
        } else {
          if (this.mySwiper instanceof Array) {
            this.mySwiper.forEach((element) => {
              element.destroy();
            });
          }
          // 每次重新创建swiper前都要销毁之前存在的轮播   不然轮播会重复
          if (this.mySwiper instanceof Object) {
            this.mySwiper.destroy();
          }
        }
      });
    },
    handleCloseOverlay() {
      this.showOverlay = false;
      if (this.timeId) clearInterval(this.timeId);
      // 每次重新创建swiper前都要销毁之前存在的轮播   不然轮播会重复
      if (this.mySwiper instanceof Object) {
        this.mySwiper.destroy();
      }
    },
    handleClickImg(item) {
      if (item.linkType == "scanCode") {
        // 调起微信扫码，扫码取号并自动跳转到扫码信息页面
        handleScanCode();
      } else if (item.linkUrl) {
        window.location.href = item.linkUrl;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.overlay_con {
  height: 100%;
  position: fixed;
  right: 0;
  left: 0;
  top: 0;
  z-index: 99;
  /* 无图片 */
  .empty_con {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 100%;
      height: 100%;
    }
  }
  ::v-deep {
    // .my-bullet-class {
    //   width: 10px;
    //   height: 10px;
    // background-color: var(--pointColor);

    .swiper-pagination-bullet {
      background-color: #fff;
      width: 14px;
      height: 14px;
      // opacity: 1;
      // &.my-bullet-active {
      //   background-color: var(--color);
      //   opacity: 1;
      // }
    }
    // }
  }
  .swiper-container {
    height: 100%;
  }
  .swiper-slide {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .skip_btn {
    position: absolute;
    // font-size: 34px;
    top: 20px;
    right: 20px;
    border-radius: 30px;
    padding: 12px 16px;
    z-index: 100;
  }
}
</style>
